// Centralized version — update this on every release
export const APP_VERSION = '0.38.7';
